<script>
    import {onMount} from 'svelte';

    import store from '../../Stores/motivo-store';

    import {url, goto} from '@sveltech/routify';

    import Loading from "../../Components/UI/Loading.svelte";
    import Error from "../../Components/UI/Error.svelte";
    import Titulo from "../../Components/UI/Titulo.svelte";
    import Migas from "../../Components/UI/Migas/Migas.svelte";
    import Miga from "../../Components/UI/Migas/Miga.svelte";
    import Formulario from "../../Components/Motivos/Edicion/Formulario.svelte";

    export let id;

    onMount(() => store.cargar(id));

    let motivo, error, errores;
    $: motivo = $store.motivo;
    $: error = $store.error;
</script>

<style>
    h2 .material-icons {
        font-size: 2.5em;
        vertical-align: bottom;
        line-height: 1;
    }

</style>

<svelte:head>
    <title>Edición de motivo</title>
</svelte:head>

<Migas>
    <Miga url={$url('/motivos')}>Motivos</Miga>
    {#if motivo}
        <Miga actual>{motivo.nombre}</Miga>
    {/if}
</Migas>

<Titulo>Edición de motivo</Titulo>

{#if $store.cargando}
    <Loading/>
{:else if error}
    <Error mensaje={error} on:cancel={() => error = null}/>
{:else if motivo}
    <Formulario on:enviado={() => $goto('/motivos')}/>
{/if}